export default "__VITE_ASSET__DNTh5yTs__"